<div class="card mb-3">
  <div class="card-body">
    <div class="card-title h4 d-flex justify-content-between align-items-center">
      Upcoming Races
      <span *ngIf="getUser()">
        <app-race-create></app-race-create>
      </span>
    </div>
    <div class="card-text" *ngIf="(upcomingRaces | async)?.length; else noUpcomingRaces">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let race of upcomingRaces | async; index as index">
            <th scope="row">{{ index + 1 }}</th>
            <td>
              <a [routerLink]="[raceDetail, race.id]">{{ race.name }}</a>
            </td>
            <td>{{ race.begin?.toDate() | date:'yyyy/MM/dd h:mm a'}}</td>
          </tr>
        </tbody>
      </table>
      </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body">
    <div class="card-title h4">Recent Races</div>
    <div class="card-text">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let race of recentRaces | async; index as index">
            <th scope="row">{{ index + 1 }}</th>
            <td>
              <a [routerLink]="[raceDetail, race.id]">{{ race.name }}</a>
            </td>
            <td>{{ race.begin?.toDate() | date:'yyyy/MM/dd h:mm a'}}</td>
          </tr>
        </tbody>
      </table>
      </div>
  </div>
</div>

<ng-template #noUpcomingRaces>
  No Upcoming Races
</ng-template>